import React from 'react'
import Navbar from '../../components/navbar'

import Typewriter from 'typewriter-effect'

import Sketch from '../../static/images/icons/sketch.png'
import Technology from '../../static/images/icons/technology.png'
import Construction from '../../static/images/icons/construction.png'
import Admin from '../../static/images/icons/admin.png'
import Procurement from '../../static/images/icons/procurement.png'
import Quality from '../../static/images/icons/quality.png'

const Expertise = () => {
  return (
    <div className='section-nav expertise'>
      <Navbar />
      <div className='section-banner'>
        <div className='head'>Our Expertise</div>

        <p>
          <div className='first'>We know </div>
          <Typewriter
            options={{ loop: true }}
            onInit={(typewriter) => {
              typewriter
                .typeString('Water!')
                .pauseFor(300)
                .deleteChars(6)
                .typeString('Waste Water!')
                .pauseFor(300)
                .deleteChars(12)
                .start()
            }}
          />
        </p>
      </div>

      <div className='expertise-water'>
        <div className='container'>
          <div className='row'>
            <div className='col-xl-6 left'>
              <i class='bi bi-droplet'></i>
              <p>Water Management.</p>
            </div>
            <div className='col-xl-4 offset-xl-1 right'>
              <div className='head'>
                <span>Water</span> - The <span>Source</span> of Life
              </div>
              <p>
                We have an expertise in developing integrated water manegement
                systems starting from intake from the source all the way to
                individual house connection.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='expertise-process'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-4'>
              <div className='expertise-process-intro'>
                <div className='head'>The Process</div>
                <p>We Do it All</p>
              </div>
            </div>
            <div className='col-md-8 card-container'>
              <div className='row'>
                <div
                  className='col-md-4 expertise-process-card'
                  data-aos='zoom-out'
                  data-aos-delay='200'
                >
                  <img src={Sketch} />
                  <div className='head'>Design & Engineering</div>
                </div>

                <div
                  className='col-md-4 expertise-process-card'
                  data-aos='zoom-out'
                  data-aos-delay='200'
                >
                  <img src={Procurement} />
                  <div className='head'>Procurement</div>
                </div>

                <div
                  className='col-md-4 expertise-process-card'
                  data-aos='zoom-out'
                  data-aos-delay='200'
                >
                  <img src={Technology} />
                  <div className='head'>Customized Technology</div>
                </div>

                <div
                  className='col-md-4 expertise-process-card'
                  data-aos='zoom-out'
                  data-aos-delay='200'
                >
                  <img src={Construction} />
                  <div className='head'>Construction</div>
                </div>

                <div
                  className='col-md-4 expertise-process-card'
                  data-aos='zoom-out'
                  data-aos-delay='200'
                >
                  <img src={Quality} />
                  <div className='head'>Field Quality Management</div>
                </div>

                <div
                  className='col-md-4 expertise-process-card'
                  data-aos='zoom-out'
                  data-aos-delay='200'
                >
                  <img src={Admin} />
                  <div className='head'>Operation & Maintenance</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='expertise-waste'>
        <div className='container'>
          <div className='row'>
            <div className='col-xl-6 left'>
              <i class='bi bi-droplet-half'></i>
              <p>Waste Water Management.</p>
            </div>
            <div className='col-xl-4 offset-xl-1 right'>
              <div className='head'>
                <span>Waste Water</span> - The <span>Rebirth</span> of Life
              </div>
              <p>
                We do integrated wastewater management including everything from
                WW collection to processing to making it reusable and
                distribution.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Expertise
